import React from 'react';
import { motion } from 'framer-motion';
import SectionHeader from '../ui/SectionHeader';
import { OUTCOMES } from '../../data/site';

export default function Outcomes() {
  return (
    <section className="section" id="outcomes">
      <div className="container">
        <SectionHeader
          eyebrow="Outcomes / 04"
          title="Numbers our clients quote in their board decks."
          lede="We don't ship deliverables, we ship outcomes. Here's the kind of compounding leverage a well-built product creates over the first 12 months."
        />

        <div className="outcomes-grid">
          {OUTCOMES.map((o, i) => (
            <motion.div
              key={o.label}
              className={'outcome-card' + (o.large ? ' large' : '')}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 0.84, 0.44, 1] }}
            >
              <div className="stat-num">{o.num}</div>
              <div className="stat-label">{o.label}</div>
              <p>{o.body}</p>
              {o.large && (
                <div className="outcome-card__footer">
                  <span className="chip" style={{ background: 'rgba(26,19,6,0.18)', color: 'var(--gold-ink)', borderColor: 'rgba(26,19,6,0.3)' }}>
                    <span className="dot" style={{ background: 'var(--gold-ink)' }} />Real outcomes · 18 engagements
                  </span>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
